/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_Val_ItemInputs */

const en_wb_operations_val_item = /** @type {(inputs: Wb_Operations_Val_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Printed welcome packs`)
};

const lv_wb_operations_val_item = /** @type {(inputs: Wb_Operations_Val_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drukātas sveiciena mapes`)
};

/**
* | output |
* | --- |
* | "Printed welcome packs" |
*
* @param {Wb_Operations_Val_ItemInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_val_item = /** @type {((inputs?: Wb_Operations_Val_ItemInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_Val_ItemInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_val_item(inputs)
	return en_wb_operations_val_item(inputs)
});